// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import UserCreate from './UserCreate';

export default compose(
  connect(
    state => ({
      app: state.app
    }),
    dispatch => ({}),
  ),
)(UserCreate);
